import { ChangeEventHandler, useEffect, useState } from "react";
import Header from "../components/Header";
import ScanModal from "../components/ScanModal";
import { useCommonUtil } from "../util/useCommonUtil";
import "./scss/driverInfo.scss";
import { rootReducer } from "../store/store";
import { useDispatch, useSelector } from "react-redux";
import SvgIcon from "@mui/material/SvgIcon";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import KeyboardWrap from "../components/Keyboard";
import * as hangul from "hangul-js";
import LisenceSelect from "../components/LisenceSelect";
import { useHistory } from "react-router-dom";
import ConfirmModal from "../components/ConfirmModal";
import { driver } from "../actions/authActions";
import AlertModal from "../components/AlertModal";
import { useLocation } from "react-router-dom";
import AdminKeyboard from "../components/AdminKeyboard";
import {
  Driver,
  DriverInfo,
  DriverValidResponse,
  DriverValidTypes,
  initialDriverInfo
} from "../types/DriverTypes";
import {
  AlertType,
  AdminLicenseCheckAlertType,
  KeyboardInputType,
  KeyboardType,
  alertType,
  equlesDlvLicenseValid,
  keyboardInputInit,
  keyboardTypeInit,
  validationItems
} from "../types/CommonType";
import axios, { AxiosResponse } from "axios";
import moment from "moment";
import { isNeedCheckLicense,generateAdminCheckPopContent, LicenseCheckType } from "../validators/driverValidators";
import axiosInstance from "../api/axiosInstance";
import AdminLicenseCheckModal from "../components/AdminLicenseCheckModal";

declare global {
  interface Window {
    addLicenseFileInfo: any; // 원하는 타입으로 설정
  }
}
type AuthState = ReturnType<typeof rootReducer>;

const adminKeyboardBasic = {
  adminLoginShow: false,
  admingLoginKeyboardShow: false,
  keyboardShow: false
}

const DriverInfo2: React.FC = () => {
  window.addLicenseFileInfo = addLicenseFileInfo;
  
  const location = useLocation();
  const locationState = location.state as { driver1Direct: boolean, driver1NeedCheckCareer: LicenseCheckType[] };
  const { driver1Direct, driver1NeedCheckCareer } = locationState;
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    formatDate,
    formatLicenseType,
    licneseAlertMsg,
    addHyphenToLicenseNumber,
    formatLicenseName,
    formatPhoneNumber,
    formatBirthDaySummary,
    parsingLicenseIssuedYear
  } = useCommonUtil();

  const [adminKeyboard, setAdminKeyboard] = useState(adminKeyboardBasic);
  const [alertInfo, setAlertInfo] = useState<AlertType>(alertType);
  const [adminLicenseCheckAlertInfo, setAdminLicenseCheckAlertInfo] = useState<AdminLicenseCheckAlertType>({
    title: "",
    content: "",
    show: false
  });

  const [confirmShow, setConfirmShow] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>("관리자 조회 실패");
  const [modalContent, setModalContent] = useState<string>("");
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [driverSelectShow, setDriverSelectShow] = useState<boolean>(false);
  const [keyboardInfo, setKeyBoardInfo] =
    useState<KeyboardType>(keyboardTypeInit);
  const [keyboardInput, setKeyboardInput] =
    useState<KeyboardInputType>(keyboardInputInit);
  const [licenseFileList, setLicenseFileList] = useState<any[]>([]);
  let [hangulArr, setHangulArr] = useState<string[]>([]);
  const [layoutName, setLayoutName] = useState<string>("default");
  const [driverValue, setDriverValue] = useState<DriverInfo>({
    ...initialDriverInfo
  });

  const resInfo = useSelector((state: AuthState) => state.store.resOneInfo);
  const data = resInfo && resInfo.data;
  const driverPrev = useSelector((state: AuthState) => state.store.driver);
  const driverInfo = driverPrev && driverPrev.data;
  const memberRegFlag = useSelector((state: AuthState) => state.store.memberRegFlag);

  const scanStart = async () => {
    const reservationId: HTMLInputElement | null = document.getElementById(
      "reservationId"
    ) as HTMLInputElement | null;

    if (reservationId) {
      reservationId.value = resInfo?.data.reservationId || "";
    }

    const inputElement: HTMLInputElement | null = document.getElementById(
      "licenseScanWaitStatus"
    ) as HTMLInputElement | null;

    const inputElement2: HTMLInputElement | null = document.getElementById(
      "kioskOperation"
    ) as HTMLInputElement | null;

    if (inputElement) {
      inputElement.value = "true";
    }
    if (inputElement2) inputElement2.value = "LicenseScan";

    // setDriverValue(prev => ({ ...prev, driverDirect: false }))
  };

  const modalControl = () => {
    setDriverValue((prev) => ({ ...prev, driverDirect: true }));
    setModalShow(false);
  };

  function addLicenseFileInfo(param: any) {
    const inputElement: HTMLInputElement | null = document.getElementById(
      "kioskRequestOperationParam"
    ) as HTMLInputElement | null;

    if (inputElement)
      setDriverValue((prev) => ({ ...prev, fileId: inputElement.value }));

    const driverName: HTMLInputElement | null = document.getElementById(
      "driverName[1]"
    ) as HTMLInputElement | null;

    const birthday: HTMLInputElement | null = document.getElementById(
      "birthday[1]"
    ) as HTMLInputElement | null;

    const licenseType: HTMLInputElement | null = document.getElementById(
      "licenseType[1]"
    ) as HTMLInputElement | null;

    const licenseNum: HTMLInputElement | null = document.getElementById(
      "licenseNum[1]"
    ) as HTMLInputElement | null;

    if (driverName){
      setDriverValue((prev) => ({ ...prev, driverName: driverName.value }));
    }
      
    if (birthday){
      setDriverValue((prev) => ({ ...prev, birthday: formatBirthDaySummary(birthday?.value) }));
    }
      
    if (licenseType){
      setDriverValue((prev) => ({ ...prev, licenseType: licenseType?.value }));
    }

    if (licenseNum){
      setDriverValue((prev) => ({ ...prev, licenseNum: addHyphenToLicenseNumber(licenseNum?.value) }));
    }

    // 부운전자 면허증 스캔 시, 주소 정보 받도록
    const address: HTMLInputElement | null = document.getElementById(
      "address[1]"
    ) as HTMLInputElement | null;

    if(address) {
      setDriverValue((prev) => ({ ...prev, address: address?.value }));
    }

    setDriverValue((prev) => ({
      ...prev,
      orderNum: 1,
      licenseFileList: [param]
    }));

    const dlvRequest = {
      licenseNo: licenseNum?.value.replace(/-/g, ""),
      residentName: driverName && driverName?.value,
      residentDate: birthday?.value,
      seqNo: "",
      licenseConCode: formatLicenseType(licenseType ? licenseType?.value : ""),
      fromDate: data?.takeoverDtm as any,
      toDate: data?.returnDtm as any,
      exportCarId: data?.carId || 0
    } as DriverValidTypes;

    if([
      dlvRequest.licenseNo,
      dlvRequest.residentName,
      dlvRequest.licenseConCode
      ].every(v => String(v ?? "").trim() !== "")){
      equlesDlvLicense(dlvRequest);
    }
  }

  const equlesDlvLicense = async (param: DriverValidTypes) => {
    try {
      const response = await axios.post<
        DriverValidTypes,
        AxiosResponse<DriverValidResponse>
      >(
        `${process.env.REACT_APP_MOBILE_API_URL}/V1/${data?.companyId}/DriverLicenseValidator.do`,
        param
      );

      if (response.data.result === "success") {
        // const currentDate = new Date();
        // const formattedDate = currentDate.toISOString().slice(0, 19).replace('T', ' ');
        setDriverValue((prev) => ({
          ...prev,
          licenseCerti: true,
          licenseCheckDtm: moment().format("YYYY-MM-DD HH:mm:ss")
        }));
      } else {
        if (response.data.message.includes("검증시스템에서")) {
          setDriverValue((prev) => ({
            ...prev,
            licenseCerti: true,
            licenseSystemError: true
          }));
          setAlertInfo({
            show: true,
            title: "면허 검증 시스템 장애",
            content:
              "면허 검증 시스템 오류로 인해<br/> 데스크에서 차키 수령시<br/>직원분이 면허정보를 추가 확인하게 됩니다."
          });
          return false;
        } else {
          setDriverValue((prev) => ({ ...prev, licenseCerti: false }));
          setAlertInfo({
            show: true,
            title: "면허 검증 실패",
            content: licneseAlertMsg(response.data.message || "")
          });
          return false;
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  /** 사용자 키보드 입력 함수 */
  const onKeyPress: ChangeEventHandler<HTMLElement> = (event) => {
    if (keyboardInfo.keyboardType === "text") {
      if (String(event) === "{shift}") {
        setLayoutName(layoutName === "default" ? "shift" : "default");
      } else if (String(event) === "{bksp}") {
        const removedPart = keyboardInput.keyboardInputValue?.slice(-1);

        setKeyboardInput((prev) => ({
          ...prev,
          keyboardInputValue: keyboardInput.keyboardInputValue?.slice(0, -1)
        }));
        const deleteArr = hangul.disassemble(removedPart || "");
        for (let i = deleteArr.length - 1; i >= 0; i--) {
          const lastIndex = hangulArr.lastIndexOf(deleteArr[i]);
          if (lastIndex !== -1) {
            hangulArr.splice(lastIndex, 1);
          }
        }
      } else {
        // 텍스트 입력 처리
        const newHangul = String(event); // 입력된 키의 텍스트 값
        hangulArr.push(newHangul); // 입력된 텍스트 값을 배열에 추가
        const newDriverValue = hangul.assemble(hangulArr); // 자음모음 합치기
        
        setKeyboardInput((prev) => ({
          ...prev,
          keyboardInputValue: newDriverValue
        }));
      }
    } else if (keyboardInfo.keyboardType === "number") {
      if (
        /^[a-zA-Z\uAC00-\uD7A3\u1100-\u11FF\u3130-\u318F\W_]+$/.test(
          String(event)
        )
      ) {
        if (String(event) === "{shift}") {
          setLayoutName(layoutName === "default" ? "shift" : "default");
        } else if (String(event) === "{bksp}") {
          const removedPart = keyboardInput.keyboardInputValue?.slice(-1);

          setKeyboardInput((prev) => ({
            ...prev,
            keyboardInputValue: keyboardInput.keyboardInputValue?.slice(0, -1)
          }));
          const deleteArr = hangul.disassemble(removedPart || "");
          for (let i = deleteArr.length - 1; i >= 0; i--) {
            const lastIndex = hangulArr.lastIndexOf(deleteArr[i]);
            if (lastIndex !== -1) {
              hangulArr.splice(lastIndex, 1);
            }
          }
        } else if (String(event) === "재입력") {
          setKeyboardInput((prev) => ({ ...prev, keyboardInputValue: "" }));
        } else if (String(event) === "지우기") {
          setKeyboardInput((prev) => ({
            ...prev,
            keyboardInputValue: prev.keyboardInputValue?.slice(0, -1)
          }));
        } else {
          // 텍스트 입력 처리
          const newHangul = String(event); // 입력된 키의 텍스트 값
          hangulArr.push(newHangul); // 입력된 텍스트 값을 배열에 추가
          const newDriverValue = hangul.assemble(hangulArr); // 자음모음 합치기
          setKeyboardInput((prev) => ({
            ...prev,
            keyboardInputValue: newDriverValue
          }));
        }
      } else if (String(event) === "재입력") {
        setKeyboardInput((prev) => ({ ...prev, keyboardInputValue: "" }));
        setDriverValue((prev) => ({
          ...prev,
          [keyboardInput.keyboardTypeName]: (prev[
            keyboardInput.keyboardTypeName
          ] = "")
        }));
      } else if (String(event) === "지우기") {
        setKeyboardInput((prev) => ({
          ...prev,
          keyboardInputValue: prev.keyboardInputValue?.slice(0, -1)
        }));
        setDriverValue((prev) => ({
          ...prev,
          [keyboardInput.keyboardTypeName]: prev[
            keyboardInput.keyboardTypeName
          ].slice(0, -1)
        }));
      } else {
        if (
          keyboardInput.keyboardTypeName === "tel" ||
          keyboardInput.keyboardTypeName === "emContactNumber"
        ) {
          if (keyboardInput.keyboardInputValue.length >= 13) { // 11글자 + 하이픈(-) 2개 포함 검증
            return false;
          }
        } else if (keyboardInput.keyboardTypeName === "licenseNum") {
          if (keyboardInput.keyboardInputValue.length >= 15) { // 12글자 + 하이픈(-) 3개 포함 검증
            return false;
          }
        } else if (keyboardInput.keyboardTypeName === "birthday") {
          if (keyboardInput.keyboardInputValue.length >= 6) {
            return false;
          }
        }
        setKeyboardInput((prev) => ({
          ...prev,
          keyboardInputValue: prev.keyboardInputValue + event
        }));
      }
    }

    // 면허 검증 상태가 true여도 운전자 이름을 수정하면 관리자를 통하게 함
    if (
      keyboardInput.keyboardTypeName === "driverName" ||
      keyboardInput.keyboardTypeName === "licenseNum"
    ) {
      setDriverValue((prev) => ({ ...prev, driverDirect: true }));
    }
  };

  const LisenceClick = (code: string) => {
    if (
      driverValue.licenseType !== formatLicenseName(formatLicenseType(code))
    ) {
      setDriverValue((prev) => ({
        ...prev,
        licenseCerti: false,
        driverDirect: true
      }));
    }
    setDriverValue((prev) => ({ ...prev, licenseType: code }));
    setDriverSelectShow(false);
  };

  const selectOnClose = () => {
    setDriverSelectShow(false);
  };

  const updateDriver = () => {
    if (keyboardInput.keyboardTypeName === "driverName") {
      if (driverValue.driverName !== keyboardInput.keyboardInputValue) {
        setDriverValue((prev) => ({
          ...prev,
          licenseCerti: false,
          driverDirect: true
        }));
      }
      setDriverValue((prev) => ({
        ...prev,
        driverName: keyboardInput.keyboardInputValue
      }));
    }
    if (keyboardInput.keyboardTypeName === "birthday")
      setDriverValue((prev) => ({
        ...prev,
        birthday: keyboardInput.keyboardInputValue
      }));
    if (keyboardInput.keyboardTypeName === "licenseNum") {
      if (driverValue.licenseNum !== keyboardInput.keyboardInputValue) {
        setDriverValue((prev) => ({
          ...prev,
          licenseCerti: false,
          driverDirect: true
        }));
      }
      setDriverValue((prev) => ({
        ...prev,
        licenseNum: addHyphenToLicenseNumber(keyboardInput.keyboardInputValue)
      }));
    }
    if (keyboardInput.keyboardTypeName === "tel") {
      setDriverValue((prev) => ({
        ...prev,
        tel: formatPhoneNumber(
          keyboardInput.keyboardInputValue
        )
      }));
    }

    setKeyboardInput((prev) => ({ ...prev, keyboardInputValue: "" }));
    hangulArr.splice(0, hangulArr.length);
    setKeyBoardInfo((prev) => ({ ...prev, keyboardShow: false }));
  };

  const validation = (): boolean => {
    for (const item of validationItems) {
      const validationResult = item.validator
        ? item.validator(driverValue[item.field], data, driverValue)
        : true; // validator 함수가 없으면 항상 true 반환
      if (validationResult !== true) {
        // validator 함수의 반환값이 true가 아니라면 오류 처리
        const errorMessage =
          typeof validationResult === "string"
            ? validationResult
            : item.errorMessage;
        setAlertInfo((prev) => ({
          ...prev,
          show: true,
          title: "운전자 정보를 입력해주세요.",
          content: `${errorMessage}`
        }));
        return false;
      }
    }

    // 위 validationItems 에서 면허증 포멧 유효성 검사는 완료함으로, 아래 validator에선 따로 검사 X
    // 25.02.25. 면허 상 경력과 보험 가입 기준 경력이 같은 경우, 면허증 발급일자 현장 확인 필요
    driverValue.needCheckCareer = isNeedCheckLicense(driverValue, data);

    return true;
  };

  const directDlvLicense = () => {
    for (const item of equlesDlvLicenseValid) {
      if (!driverValue[item.field]) {
        setAlertInfo((prev) => ({
          ...prev,
          show: true,
          title: "운전자 정보를 입력해주세요.",
          content: `${item.errorMessage}`
        }));
        return false;
      }
    }

    const dlvRequest = {
      licenseNo: driverValue.licenseNum.replace(/-/g, ""),
      residentName: driverValue.driverName,
      residentDate: formatDate(driverValue.birthday),
      seqNo: "",
      licenseConCode: formatLicenseType(driverValue.licenseType),
      fromDate: data?.takeoverDtm as any,
      toDate: data?.returnDtm as any,
      exportCarId: data?.carId || 0
    };
    equlesDlvLicense(dlvRequest);
  };

  const adminCheckPopCallback = async (data: any) => {
    try{
      await axiosInstance()
        .post(`/kiosk/adminSameCheck.do`, {
          companyId: resInfo?.data.companyId,
          userId: data.userId,
          userPassword: data.userPassword,
          kioskLoginPwd: data.userPassword,
        })
        .then((res) => {
          if (res.data.status === 400) {
            setModalContent(res.data.resultMsg);
            setModalShow(true);
            return false;
          } else {
            if(driverInfo) {
              driverInfo.map((driverValue) => {
                driverValue.isAdminManualCheck = true;
              });
              dispatch(driver(driverInfo));
            }

            resInfo?.data.preRegStatus === "N"
              ? history.push("/contract")
              : history.push("/addIns")
          }
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 에러",
          content: "에러가 발생했습니다.<br/>다시 시도해주세요.",
          callback: () => window.location.reload()
      });
    }
  }

  const checkEqualsDriverInfo = (driver1st: Driver, driver2nd: Driver) => {
    // 04-18 부운전자 연락처 검증 제외
    // 주운전자 - 비상연락처 동일 여부만 체크
    // const driver1stTel = formatPhoneNumber(driver1st.tel || "");
    // const driver2ndTel = formatPhoneNumber(driver2nd.tel || "");
    // if(driver1stTel === driver2ndTel) {
    //   setAlertInfo({
    //     show: true,
    //     title: "입력정보 확인 필요",
    //     content: "주운전자 연락처와 다르게 입력해주세요.",
    //   });
    //   return true;
    // }

    const driver1stLicenseNumber = addHyphenToLicenseNumber(driver1st.licenseNum || "");
    const driver2ndLicenseNumber = addHyphenToLicenseNumber(driver2nd.licenseNum || "");
    if(driver1stLicenseNumber === driver2ndLicenseNumber) {
      setAlertInfo({
        show: true,
        title: "입력정보 확인 필요",
        content: "주운전자와 운전면허 정보가 동일합니다.<br>면허번호를 수정하거나, 다른 면허증을 재촬영해주세요.",
      });
      return true;
    }

    return false;
  }

  const NextButton = () => {
    if (validation()) {
      const driver2 = {
        driverName: driverValue.driverName,
        tel: formatPhoneNumber(driverValue.tel),
        birthday: formatDate(driverValue.birthday),
        address: driverValue.address,
        licenseNum: driverValue.licenseNum,
        licenseType: driverValue.licenseType,
        licenseCerti: driverValue.licenseCerti,
        licenseFileGroupId:driverValue.licenseFileGroupId,
        licenseFileList: driverValue.licenseFileList,
        companyId: resInfo?.data.companyId || "",
        reservationId: resInfo?.data.reservationId || "",
        fileId: driverValue.fileId || "",
        driverDirect: driverValue.driverDirect,
        needCheckCareer: driverValue.needCheckCareer, // 25.02.25 면허증 현장 확인 필요 여부 추가
        licenseCheckDtm: driverValue.licenseCheckDtm,
        orderNum: 1,
        singImg:
          driverInfo && driverInfo[1] && driverInfo[1].singImg
            ? driverInfo[1].singImg
            : "",
        memberRegFlag: driverValue.memberRegFlag
      };
      
      if (driverInfo) {
        driverInfo[1] = driver2;

        const driver1st = driverInfo[0];
        const driver2nd = driverInfo[1];
        if(checkEqualsDriverInfo(driver1st, driver2nd)) {
          return false;
        }

        dispatch(driver(driverInfo));

        // 주운전자 정보 : 이름 / 면허 취득 년도 
        // 부운전자 정보 : 이름 / 면허 취득 년도

        if (
          (driver1NeedCheckCareer && driver1NeedCheckCareer.length > 0 && !driver1st.isAdminManualCheck) ||
          (driverValue.needCheckCareer && driverValue.needCheckCareer.length > 0 && !driver2nd.isAdminManualCheck)
        ) {
          const noticeMessage = generateAdminCheckPopContent(resInfo?.data || {}, driver1st, driverValue);

          setAdminLicenseCheckAlertInfo({
            show: true,
            title: "면허증 확인 필요",
            content: "면허증 확인이 필요합니다. 직원에게 문의하세요." + noticeMessage,
            callback: () => {
              setAdminKeyboard(prev => ({ ...prev, keyboardShow: true,}));
            }
          });

          return false;
        } else if (driver1Direct || driverValue.driverDirect) {
          setAlertInfo({
            show: true,
            title: "관리자 확인 필요",
            content: "면허 정보를 직접 입력시, 인수할 때 관리자에게 면허증을 보여주세요.",
            callback: () =>
              resInfo?.data.preRegStatus === "N"
                ? history.push("/contract")
                : history.push("/addIns")
          });
          return false;
        } else {
          resInfo?.data.preRegStatus === "N"
            ? history.push("/contract")
            : history.push("/addIns");
        }
      }
    }
  };

  useEffect(() => {
    if (driverInfo && !driverInfo[1]) {
      setModalShow(true);
    } else {
      const info = driverInfo && driverInfo[1];
      if (info) {
        setDriverValue((prevState) => ({
          ...prevState,
          companyId: info?.companyId || "",
          reservationId: String(info?.reservationId),
          // orderNum: 1,
          driverName: info?.driverName || "",
          tel: formatPhoneNumber(info?.tel || "") || "",
          address: info?.address || "",
          // emContactNumber: formatPhoneNumber(info?.emContactNumber || "") || "",
          birthday: formatDate(info?.birthday || "") || "",
          licenseNum: info?.licenseNum || "",
          licenseCheckDtm: info?.licenseCheckDtm,
          licenseType: info?.licenseType || "" || "",
          licenseCerti: !!info?.licenseCerti,
          licenseFileList: info?.licenseFileList,
          fileId: info?.fileId || "",
          driverDirect: info?.driverDirect,
          memberRegFlag: !!memberRegFlag,
          licenseFileGroupId:info?.licenseFileGroupId
        }));
      }
    }

    setDriverValue((prev) => ({...prev, orderNum: 1}));

    if (driverInfo && driverInfo[1] && !driverInfo[1].licenseCerti) {
      setDriverValue((prev) => ({ ...prev, driverDirect: true }));
    }

    if (driverInfo && !driverInfo[1]) {
      setModalShow(true);
    }

    // 주운전자 등록시 입력한 비상연락처 등록
    // 04-18 부운전자 연락처는 검증에서 제외 (주운전자, 비상연락처 동일 여부만 체크)
    // if(driverInfo && driverInfo[0] && driverInfo[0].emContactNumber) {
    //   const emContactNumber = driverInfo[0].emContactNumber;
    //   setDriverValue((prev) => ({ ...prev, emContactNumber: emContactNumber}));
    // }
  }, [driverInfo]);
  return (
    <>
      <Header
        onConfirm={() => {
          setConfirmShow(true);
        }}
      ></Header>
      {adminLicenseCheckAlertInfo.show && (
        <AdminLicenseCheckModal
          callback={() => {
            if (adminLicenseCheckAlertInfo.callback) {
              adminLicenseCheckAlertInfo.callback();
            }
          }}
          onClose={() => {
            setAdminLicenseCheckAlertInfo((prev) => ({ ...prev, show: false }));
          }}
          title={adminLicenseCheckAlertInfo.title}
          content={adminLicenseCheckAlertInfo.content}
        ></AdminLicenseCheckModal>
      )}
      {alertInfo.show && (
        <AlertModal
          onClose={() => {
            if (alertInfo.callback) {
              alertInfo.callback(); // 콜백 함수 호출
            } else setAlertInfo((prev) => ({ ...prev, show: false }));
          }}
          title={alertInfo.title}
          content={alertInfo.content}
        ></AlertModal>
      )}

      <ConfirmModal
        isOpen={confirmShow}
        title={"등록을 취소하시겠습니까?"}
        message={
          "부 운전자 등록을 취소하고 이전페이지로 돌아갑니다.<br/>등록하지 않는 경우 비상연락처를 입력해주세요."
        }
        onCancel={() => {
          setConfirmShow(false);
        }}
        onConfirm={() => {
          setDriverValue(initialDriverInfo);
          if (driverInfo) {
            if (driverInfo[1]) {
              driverInfo.pop();
            }
            dispatch(driver(driverInfo));
          }
          history.goBack();
        }}
      ></ConfirmModal>
      {modalShow && (
        <ScanModal
          onDirectClick={() => {
            setDriverValue((prev) => ({ ...prev, driverDirect: true }));
            setModalShow(false);
          }}
          offDirectClick={() => {
            setDriverValue((prev) => ({ ...prev, driverDirect: false }));
          }}
          onClick={() => {
            scanStart();
          }}
          onClose={() => {
            modalControl();
          }}
        ></ScanModal>
      )}
      <div className="driver-wrap">
        <div className="driver-title-wrap">
          <span>부 운전자</span>
          <div className="rent-dec">
            <>
              만 {data?.rentCondAge}세, 운전경력 {data?.rentCondLicenseYear}년
              이상 운전자만 차량 대여가 가능합니다.
            </>
          </div>
        </div>
        <div className="driver-info-wrap">
          <div className="lisence-wrap">
            <div className="img-wrap">
              {driverValue.fileId ? (
                <img
                  src={`${
                    process.env.REACT_APP_DOMAIN
                  }/Common/File/Download.do?fileId=${
                    driverValue.fileId
                      ? driverValue.fileId
                      : driverInfo && driverInfo[1] && driverInfo[1].fileId
                  }`}
                  alt="Image"
                />
              ) : (
                <div className="no-img">이미지 없음</div>
              )}
            </div>

            <div className="refresh-wrap" onClick={() => setModalShow(true)}>
              <SvgIcon
                component={RefreshOutlinedIcon}
                color="disabled"
                style={{
                  fontSize: "1.8em",
                  color: "gray",
                  marginRight: "7px"
                }}
              ></SvgIcon>
              <span>재촬영</span>
            </div>
          </div>

          <div className="driver-info">
            <div className="driver-name">이름</div>
            <div
              className="info-wrap"
              onClick={() => {
                setKeyBoardInfo((prev) => ({
                  ...prev,
                  keyboardType: "text",
                  keyboardShow: true
                }));
                setKeyboardInput((prev) => ({
                  ...prev,
                  keyboardTypeName: "driverName",
                  keyboardDecript: "부 운전자 “이름”을 입력하세요.",
                  keyboardInputValue: driverValue.driverName
                }));

                hangulArr.length = 0; // hangulArr 초기화
                hangulArr.push(...hangul.disassemble(driverValue.driverName)); // 기존 driverName을 분해해서 채워줌
              }}
            >
              <div style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}>
                {" "}
                {driverValue.driverName}
              </div>

              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>
          <div className="driver-info">
            <div className="driver-name">생년월일</div>
            <div
              className="info-wrap"
              onClick={() => {
                setKeyBoardInfo((prev) => ({
                  ...prev,
                  keyboardType: "number",
                  keyboardShow: true
                }));
                setKeyboardInput((prev) => ({
                  ...prev,
                  keyboardTypeName: "birthday",
                  keyboardDecript: "부 운전자 “생년월일”를 6자리를 입력하세요.",
                  keyboardInputValue: driverValue.birthday
                }));
              }}
            >
              <div
                style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
              >
                {" "}
                {driverValue.birthday ? formatDate(driverValue.birthday) : ""}
              </div>
              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>
          <div className="driver-info">
            <div className="driver-name">면허종류</div>
            <div
              className="info-wrap"
              onClick={() => {
                setDriverSelectShow(true);
              }}
            >
              <div
                style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
              >
                {driverValue.licenseType ? (
                  formatLicenseName(
                    formatLicenseType(driverValue.licenseType || "")
                  )
                ) : (
                  <div style={{ color: "red" }}>
                    운전자 면허종류를 선택해주세요.
                  </div>
                )}
              </div>
              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>

          <div className="driver-info">
            <div className="driver-name">면허번호</div>
            <div
              className="info-wrap"
              onClick={() => {
                setKeyBoardInfo((prev) => ({
                  ...prev,
                  keyboardType: "number",
                  keyboardShow: true
                }));
                setKeyboardInput((prev) => ({
                  ...prev,
                  keyboardTypeName: "licenseNum",
                  keyboardDecript: "부 운전자 “면허번호”를 입력하세요.",
                  keyboardInputValue: driverValue.licenseNum
                }));
              }}
            >
              <div
                style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
              >
                {driverValue.licenseNum ? (
                  addHyphenToLicenseNumber(driverValue.licenseNum)
                ) : (
                  <div style={{ color: "red" }}>
                    운전자 면허번호를 입력해주세요.
                  </div>
                )}
              </div>

              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>

          <div className="driver-info">
            <div className="driver-name">면허검증</div>
            <div className="info-wrap">
              <div
                style={{
                  width: "15%",
                  textAlign: "center",
                  fontWeight: "600",
                  marginLeft: "1em",
                  padding: "5px",
                  background: "#F6F7FB",
                  borderRadius: "0.3em",
                  border: "1.5px solid #E4E7EC"
                }}
              >
                {driverValue.licenseCerti ? (
                  <span style={{ color: "#3E83F1" }}>인증 완료</span>
                ) : (
                  <span style={{ color: "#FF5353" }}>인증 안됨</span>
                )}
              </div>
              {!driverValue.licenseCerti && (
                <div
                  className="driver-certification"
                  onClick={() => {
                    directDlvLicense();
                  }}
                >
                  <SvgIcon
                    component={VerifiedOutlinedIcon}
                    color="disabled"
                    style={{
                      fontSize: "1.5em",
                      color: "white",
                      marginRight: "7px"
                    }}
                  ></SvgIcon>
                  인증
                </div>
              )}
            </div>
          </div>

          <div
            className="driver-info"
            style={{ borderBottom: "2px solid #e4e7ec" }}
          >
            <div className="driver-name">연락처</div>
            <div
              className="info-wrap"
              onClick={() => {
                setKeyBoardInfo((prev) => ({
                  ...prev,
                  keyboardType: "number",
                  keyboardShow: true
                }));
                setKeyboardInput((prev) => ({
                  ...prev,
                  keyboardTypeName: "tel",
                  keyboardDecript: "부 운전자 “연락처”를 입력하세요.",
                  keyboardInputValue: driverValue.tel
                }));
              }}
            >
              <div
                style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
              >
                {driverValue.tel ? (
                  formatPhoneNumber(driverValue.tel)
                ) : (
                  <div style={{ color: "red" }}>
                    운전자 전화번호를 입력해주세요.
                  </div>
                )}
              </div>
              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>

          <div className="driver2-regis">
            <span>
              {/* 부 운전자 등록을 취소하시려면 아래 버튼을 클릭하여
              <br /> 이전 페이지로 돌아가 비상연락처를 필수 입력해주세요! */}
              부 운전자 등록을 취소하시려면 아래 버튼을 클릭해주세요.
            </span>

            <div
              className="btn-wrap"
              style={{
                width: "30%",
                fontSize: "10px"
              }}
            >
              <button
                onClick={() => {
                  setConfirmShow(true);
                }}
                style={{
                  background: "white",
                  color: "#3e83f1",
                  borderRadius: "2em",
                  border: "2px solid #3e83f1",
                  boxShadow: "none"
                }}
              >
                등록 취소하기
              </button>
            </div>
          </div>
        </div>
        <div className="btn-wrap" style={{ width: "100%" }}>
          <button
            onClick={() => {
              NextButton();
            }}
          >
            다음 단계로
          </button>
        </div>
      </div>
      {keyboardInfo.keyboardShow && (
        <div>
          <KeyboardWrap
            type={keyboardInfo.keyboardType}
            onClick={updateDriver}
            layoutName={layoutName}
            driverNameInput={keyboardInput.keyboardInputValue}
            titleDec={keyboardInput.keyboardDecript}
            onKeyPress={onKeyPress}
            onClose={() => {
              setKeyboardInput((prev) => ({ ...prev, keyboardInputValue: "" }));
              setKeyBoardInfo((prev) => ({ ...prev, keyboardShow: false }));
            }}
          ></KeyboardWrap>
        </div>
      )}
      {driverSelectShow && (
        <LisenceSelect
          licenseType={driverValue.licenseType}
          onClick={LisenceClick}
          onClose={selectOnClose}
        ></LisenceSelect>
      )}
      {adminKeyboard.keyboardShow && (
        <AdminKeyboard
          title="운전경력 확인을 위해 직원을 호출해주세요."
          companyId={resInfo?.data?.companyId}
          show={adminKeyboard.keyboardShow}
          onClose={() => {
            setAdminKeyboard(prev => ({ ...prev, keyboardShow: false }))
          }}
          onCallback={adminCheckPopCallback}
        ></AdminKeyboard>
      )}
      <input type="hidden" name="companyId" id="companyId" value={resInfo?.data?.companyId}></input>
      <input type="hidden" name="licenseScanWaitStatus" id="licenseScanWaitStatus" value="false" ></input>
      <input type="hidden" name="licenseScanReturnMsg" id="licenseScanReturnMsg" value=""></input>
      <input type="hidden" name="kioskOperation" id="kioskOperation" value=""></input>
      <input type="hidden" name="licenseScanTimeout" id="licenseScanTimeout" value=""></input>
      <input type="hidden" name="driverName[1]" id="driverName[1]" value=""></input>
      <input type="hidden" name="birthday[1]" id="birthday[1]" value=""></input>
      <input type="hidden" name="licenseType[1]" id="licenseType[1]" value="" ></input>
      <input type="hidden" name="licenseNum[1]" id="licenseNum[1]" value=""></input>
      <input type="hidden" name="address[1]" id="address[1]" value=""></input>
      <input type="hidden" name="kioskRequestOperation" id="kioskRequestOperation" value=""></input>
      <input type="hidden" name="kioskRequestOperationParam" id="kioskRequestOperationParam" value=""></input>
      <input type="hidden" name="reservationId" id="reservationId" value="" />
      <input id="scanTarget" value="driverInfo02" type="hidden"></input>
    </>
  );
};

export default DriverInfo2;
